import { render } from "./reminder.vue?vue&type=template&id=27f00bac"
import script from "./reminder.vue?vue&type=script&lang=js"
export * from "./reminder.vue?vue&type=script&lang=js"

import "./reminder.vue?vue&type=style&index=0&id=27f00bac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__